<template>
    <nav class="pagination is-centered" v-if="numPages > 1">
        <slot></slot>
        <ul class="pagination-list">
            <li v-for="page in pages">
                <span v-if="page == '...'">{{page}}</span>
                <router-link exact v-if="page == '<' && previousPage != currentPage" class="button" :class="{ 'is-loading': loading }" :to="getUrlParams(previousPage)">&lt;</router-link>
                <router-link exact v-if="page == '>' && nextPage != currentPage" class="button" :class="{ 'is-loading': loading }" :to="getUrlParams(nextPage)">&gt;</router-link>
                <router-link exact v-if="page == '<<' && currentPage != 1" class="button" :class="{ 'is-loading': loading }" :to="getUrlParams(1)">&lt;&lt;</router-link>
                <router-link exact v-if="page == '>>' && currentPage != numPages" class="button" :class="{ 'is-loading': loading }" :to="getUrlParams(numPages)">&gt;&gt;</router-link>
                <router-link exact class="button" :class="{ 'is-loading': loading, 'is-active': (!$route.query.page && page == 1) || $route.query.page == page }" :to="getUrlParams(page)" v-if="!isNaN(page)">{{ page }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { AppModel } from '../../../models';

    export default {
        name: 'pagination',
        props: {
            params: {
                type: Object,
                'default': {}
            },
            currentPage: {
                type: Number,
                'default': 1
            },
            limit: {
                type: Number,
                'default': 20
            },
            numPages: {
                type: Number
            },
            visiblePages: {
                type: Number,
                'default': 5
            },
            loading: {
                type: Boolean,
                'default': false
            },
            removeFromQuery: {
                type: Array,
                'default': () => {
                    return [];
                }
            },
        },

        computed: {
            nextPage() {
                return Math.min(this.numPages, this.currentPage + 1);
            },

            previousPage() {
                return Math.max(1, this.currentPage - 1);
            },

            pages() {
                let p = [];

                let pg = 1;
                if(this.visiblePages >= this.numPages) {
                    while(pg <= this.numPages) {
                        p.push(pg);
                        pg++;
                    }
                    return p;
                }

                const half = Math.floor(this.visiblePages / 2);
                let start = this.currentPage - half + 1 - this.visiblePages % 2;
                let end = this.currentPage + half;

                if(start <= 0) {
                    start = 1;
                    end = this.visiblePages;
                }
                if(end > this.numPages) {
                    start = this.numPages - this.visiblePages + 1;
                    end = this.numPages;
                }

                pg = start;
                while(pg <= end) {
                    p.push(pg);
                    pg++;
                }

                if(p[0] !== 1) {
                    p.splice(0, 0, '...');
                }

                p.splice(0, 0, '<');
                p.splice(0, 0, '<<');

                if(p[p.length - 1] !== this.numPages) {
                    p.push('...');
                }

                p.push('>');
                p.push('>>');

                return p;
            }
        },
        methods: {
            getUrlParams(page) {
                let query = Object.assign({}, this.$route.query);
                query = Object.assign(query, { page: page });
                for(let field of this.removeFromQuery) {
                    if(query[field]) {
                        delete query[field];
                    }
                }
                return {
                    name: this.$route.name,
                    query: query,
                    params: {lang: AppModel.lang},
                };
            },
        }
    };
</script>

<style lang="scss">
    @import './pagination.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/pagination/pagination.vue